<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="submit-page">
        <h3>Basic Property Information</h3>
        <form (ngSubmit)="Submit()" class="submit-section" #propertyForm="ngForm">
          <div class="row with-forms">
            <div class="col-md-6">
              <h5> Property Title: <i class="fa fa-asterisk"></i></h5>
              <input class="input-text" type="text" value="" name="propertyTitle" [(ngModel)]="Title" required
                #propertyTitleControl="ngModel" maxlength="200" />
              <div class="notification error" *ngIf="propertyTitleControl.invalid && propertyTitleControl.touched">
                <p>Property title field is required</p>
              </div>
            </div>
            <div class="col-md-6">
              <h5> Property Price: <i class="fa fa-asterisk"></i></h5>
              <input type="text" maxlength="9" (keypress)="numberOnly($event)" onpaste="return false;" ondrag="return false;" ondrop="return false;" class="input-text" name="price" [(ngModel)]="Price" required
                #propertyPriceControl="ngModel" />
              <div class="notification error" *ngIf="propertyPriceControl.invalid && propertyPriceControl.touched">
                <p>Property price field is required</p>
              </div>
            </div>
          </div>

          <div class="row with-forms">
            <div class="col-md-6">
              <h5 id="IDPurpose">Purpose: <i class="fa fa-asterisk"></i></h5>
              <ng-select [items]="PurposeDropdown" bindLabel="Text" bindValue="Id" [(ngModel)]="PurposeId"
                name="purpose" required #propertyPurposeControl="ngModel">
              </ng-select>
              <div class="notification error" *ngIf="propertyPurposeControl.invalid && propertyPurposeControl.touched">
                <p>Purpose field is required</p>
              </div>
            </div>
            <div class="col-md-6">
              <h5 id="IDType">Property Type: <i class="fa fa-asterisk"></i></h5>
              <ng-select [items]="TypesDropdown" bindLabel="Text" bindValue="Id" [(ngModel)]="TypeId" name="propType"
              (change)="changePropertyType()" required #propertyTypeControl="ngModel">
              </ng-select>
              <div class="notification error" *ngIf="propertyTypeControl.invalid && propertyTypeControl.touched">
                <p>Property type field is required</p>
              </div>
            </div>
          </div>
          <div class="row with-forms" *ngIf="showFields">
            <div class="col-md-6">
              <h5>Bedrooms: <span>(optional)</span></h5>
              <ng-select [items]="BedRoomsDropdownData" bindLabel="Text" bindValue="Id" [(ngModel)]="BedRoomId"
                name="bedroom">
              </ng-select>
            </div>
            <div class="col-md-6">
              <h5>Bathrooms: <span>(optional)</span></h5>
              <ng-select [items]="BathRoomsDropdown" bindLabel="Text" bindValue="Id" [(ngModel)]="BathRoomId"
                name="bathroom">
              </ng-select>
            </div>
          </div>
          <div class="row with-forms">
            <div class="col-md-6">
              <h5>Property Area: <i class="fa fa-asterisk"></i></h5>
              <div>
                <input type="text" maxlength="9" (keypress)="numberOnly($event)" onpaste="return false;" ondrag="return false;" ondrop="return false;" class="input-text" [(ngModel)]="Area" name="ProArea" name="area" required
                  #propertyAreaControl="ngModel" />
              </div>
              <div class="notification error" *ngIf="propertyAreaControl.invalid && propertyAreaControl.touched">
                <p>Property area field is required</p>
              </div>
            </div>
            <div class="col-md-6">
              <h5>Area Unit: <i class="fa fa-asterisk"></i></h5>
              <ng-select [items]="AreaUnitsDropdown" bindLabel="Text" bindValue="Id" [(ngModel)]="AreaUnitId"
                name="areaUnit" required #propertyAreaUnitControl="ngModel">
              </ng-select>
              <div class="notification error"
                *ngIf="propertyAreaUnitControl.invalid && propertyAreaUnitControl.touched">
                <p>Area unit field is required</p>
              </div>
            </div>
          </div>
          <h3>Detailed Information</h3>
          <div class="submit-section">
            <div class="form">
              <h5 id="IDDescription">Description: <i class="fa fa-asterisk"></i></h5>
             <quill-editor class="custom-quill" [(ngModel)]="Description"   name="summary"  [modules]="editorModules" required #propertyDescriptionControl="ngModel" #propertyDescriptionRef></quill-editor>
                <div class="notification error"
                  *ngIf="propertyDescriptionControl.invalid && propertyDescriptionControl.touched">
                  <p>Description field is required</p>
                </div>
            </div>
            <h3>City & Location Information</h3>
            <div class="submit-section">
              <div class="row with-forms">
                <div class="col-md-6">
                  <h5>City: <i class="fa fa-asterisk"></i></h5>
                  <ng-select [items]="CitiesDropdown" bindLabel="Text" bindValue="Id" [(ngModel)]="CityId" name="city"
                    (change)="changeCity()" required #propertyCityControl="ngModel">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                      <div class="ng-value" *ngFor="let item of items | slice:0:1">
                        <span class="ng-value-label">
                          <i class="im im-icon-Location"></i>
                          {{item.Text}}</span>
                        <span class="ng-value-icon right" aria-hidden="true">×</span>
                      </div>
                    </ng-template>
                  </ng-select>
                  <div class="notification error" *ngIf="propertyCityControl.invalid && propertyCityControl.touched">
                    <p>City field is required</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <h5>Loaction: <span>(optional)</span></h5>
                  <ng-select [items]="LocationsDropdown" bindLabel="Text" bindValue="Id" [(ngModel)]="LocationId"
                    name="location" #propertyLocationControl="ngModel">
                  </ng-select>
                   <div class="notification error"
                    *ngIf="propertyLocationControl.invalid && propertyLocationControl.touched">
                    <p>Location field is required</p>
                  </div>
                </div>
              </div>
            </div>
            <h5>Property Images: <span>(optional)</span></h5>
            <div class="row">
              <div class="col-md-12">
                <div class="submit-section">
                  <div class="container-images">
                    <div class="container-images-section">
                      <ol class="list-image">
                        <li *ngFor="let image of urls;let i = index" class="container-image">
                          <div class="full-w-h">
                            <img class="image" [src]="image" />
                            <span class="cover-image" *ngIf="i==0">Cover Image</span>
                            <a class="icon-close" (click)="onRemove(i)"><i class="sl sl-icon-close"></i></a>
                          </div>
                        </li>
                      </ol>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                      <div class="add-image label-color" (click)="addImage()">
                        <div class="empty-container"><span class="camera-container"><i class="im im-icon-Camera-3"
                              title=""></i></span>
                          <div class="add-property-label"><span>Add Property Image</span></div>
                        </div>
                      </div>
                    </div>
                    <input id="image-upload" name="propertyImages" accept="image/png, image/jpeg" type="file"
                      multiple="" autocomplete="off" style="display: none;" (change)="uploadImages($event)">
                  </div>
                </div>
              </div>
            </div>
            <h3>Contact Details</h3>
            <div class="submit-section">
              <div class="row with-forms">
                <div class="col-md-4">
                  <h5>Full Name: <i class="fa fa-asterisk"></i></h5>
                  <input type="text" name="fullName" maxlength="70" class="form-control input-text" [(ngModel)]="fullName" required
                    #fullNameControl="ngModel" />
                  <div class="notification error" *ngIf="fullNameControl.invalid && fullNameControl.touched">
                    <p>Full Name is required.</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <h5>Email Address: <i class="fa fa-asterisk"></i></h5>
                  <input name="emailAddress" type="email" [(ngModel)]="emailAddress" class="input-text" maxlength="100"
                    pattern="^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$"
                    required #emailAddressControl="ngModel" />

                  <div class="notification error"
                    *ngIf="(emailAddressControl.value == undefined || emailAddressControl.value == '') && emailAddressControl.touched">
                    <p> Email address field is required</p>
                  </div>
                  <div class="notification error"
                    *ngIf="emailAddressControl.value != undefined && emailAddressControl.value.length > 5 && emailAddressControl.invalid && emailAddressControl.touched">
                    <p> Email address is invalid</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <h5>Phone: <i class="fa fa-asterisk"></i></h5>
                  <input name="text" type="phone" maxlength="16" (keypress)="numberOnly($event)" onpaste="return false;" ondrag="return false;" ondrop="return false;" [(ngModel)]="phoneNumber" class="input-text" required
                    #phoneNumberControl="ngModel" />
                  <div class="notification error" *ngIf="phoneNumberControl.invalid && phoneNumberControl.touched">
                    <p> Phone number field is required</p>
                  </div>
                </div>
              </div>
            </div>
            <h5  *ngIf="showFields" class="margin-top-30">Other Features: <span>(optional)</span></h5>
            <div  *ngIf="showFields" class="submit-section">
              <div class="row with-forms">
                <div class="col-md-12 checkboxes in-row">
                  <div class="row">
                    <div class="col-md-3" *ngFor="let otherFeature of OtherFeatures">
                      <input id="checkbox-{{otherFeature.Id}}" type="checkbox" value="{{otherFeature.Id}}"
                        [(ngModel)]="otherFeature.IsChecked" name="checkbox-{{otherFeature.Id}}">
                      <label for="checkbox-{{otherFeature.Id}}">{{otherFeature.Text}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <input type="submit" class="submit button" id="submit" value="Save Changes"
              [disabled]="propertyForm.invalid" />
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
